import { seriesNames } from 'helpers/kpiBuilder/seriesRecipes';
import { BuilderSection } from './BuilderSection';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';

// Legend names of the first two bars. Left blank, they are named from the data and the trait.
export const BarNamesStep = ({ a, patch }: StepProps) => {
  const auto = seriesNames({ ...a, custom: { ...a.custom, firstBar: '', secondBar: '' } });
  const set = (next: Partial<typeof a.custom>) => patch({ custom: { ...a.custom, ...next } });

  return (
    <BuilderSection title="Bar names (optional)" hint="The names shown in the chart legend, for example “Activation” and “Passed”. Leave a name blank to use the automatic one.">
      <TextBox value={a.custom.firstBar} placeholder={`First bar, e.g. ${auto[0]}`} onChange={(firstBar) => set({ firstBar })} />
      <div className="mt-1">
        <TextBox value={a.custom.secondBar} placeholder={`Second bar, e.g. ${auto[1] || 'Passed'}`} onChange={(secondBar) => set({ secondBar })} />
      </div>
    </BuilderSection>
  );
};
